import { Routes, Route } from 'react-router-dom';
import { useState, useEffect } from 'react';
import HomePage from './pages/HomePage';
import BlogPost from './pages/BlogPost';
import Secret from './pages/Secret';

const fullText = "\n> Initializing system...\n> Loading defenses...\n> Fetching Rust API endpoints...\n> Construction Ahead...\n> Welcome.";

function App() {
  const [showIntro, setShowIntro] = useState(true);
  const [typedText, setTypedText] = useState('');

  useEffect(() => {
    if (!showIntro) return;
    let currentIndex = 0;
    let doneTimeout;
    const typingInterval = setInterval(() => {
      currentIndex++;
      setTypedText(fullText.slice(0, currentIndex));
      if (currentIndex >= fullText.length) {
        clearInterval(typingInterval);
        doneTimeout = setTimeout(() => setShowIntro(false), 2000);
      }
    }, 50);
    return () => {
      clearInterval(typingInterval);
      clearTimeout(doneTimeout);
    };
  }, [showIntro]);

  useEffect(() => {
    const handleScroll = () => { if (window.scrollY > 10) setShowIntro(false); };
    if (showIntro) window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [showIntro]);

  return (
    <>
      {showIntro && (
        <div className="terminal-overlay" onClick={() => setShowIntro(false)}>
          <div className="terminal-text">
            {typedText}
            <span className="cursor">_</span>
          </div>
        </div>
      )}

      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/secret" element={<Secret/>} />
      </Routes>
    </>
  );
}

export default App;